import {
  setAutoBpmAutomix, setBpmAutomix, setCurrentAutomix, setCurrentPlayAutomix,
  setStateAutomix, setUidAutomix, setSettingHideAutomix, setCurrentIdAutomix,
  setRandomAutomix
} from "./redux/actions/index";

/* Public Methods Available For LRoot */
function Root(Base, store) {
  class NewRoot extends Base {

    loadsong_request(pid, isFirst = false) {
      const state = store.getState();
      state.storeAutomix.load(pid, isFirst);
    }
    automix_off() {
      const state = store.getState();
      state.storeAutomix.disable();
    }
    automix_state(state) {
      if (!state) {
        store.dispatch(setUidAutomix(null));
        store.dispatch(setCurrentIdAutomix(null));
      }
    }
    automix_shuffle(_enable = null) {
      if (_enable === null) {
        const state = store.getState();
        return state.isRandomAutomix;
      } else {
        store.dispatch(setRandomAutomix(_enable));
      }
    }
    automix_hide(status) {
      store.dispatch(setSettingHideAutomix(status));
    }
    automix_info(data) {
      const state = store.getState();
      if (state.currentIdAutomix !== data.currentid) {
        store.dispatch(setCurrentIdAutomix(data.currentid));
      }
      if (state.autoBpmAutomix !== data.autobpm) { store.dispatch(setAutoBpmAutomix(data.autobpm)); }
      if (state.bpmAutomix !== data.bpm) { store.dispatch(setBpmAutomix((Math.round(data.bpm * 10) / 10).toFixed(1))); }
      if (state.stateAutomix !== data.state) {
        store.dispatch(setStateAutomix(data.state));
      }
      if (state.isCurrentPlayAutomix !== data.playing) { store.dispatch(setCurrentPlayAutomix(data.playing)); }
      if ((data.position - state.currentAutomix.position > 1) || (data.position - state.currentAutomix.position < -1) || ((data.state === 'mixing' || data.state === 'skipping') && data.mixingprogress > 1)) {
       store.dispatch(setCurrentAutomix(data));
      }
    }

  }
  return NewRoot;
}

export default Root;
